import { competitorAPIClient } from "../competitorAPIClient";
import { queryOptions } from "@tanstack/react-query";
import { COMPETITOR_QUERY_KEYS } from "./keys";
import type { CompetitorMatchedProductsRequest } from "./types";

export const COMPETITOR_QUERIES = {
  getCompetitorMatchedProducts: ({
    enabled,
    ...params
  }: CompetitorMatchedProductsRequest) =>
    queryOptions({
      queryKey: COMPETITOR_QUERY_KEYS.matchedProducts(params),
      queryFn: () => competitorAPIClient.getCompetitorMatchedProducts(params),
      enabled,
    }),
};
